const text = (value: unknown): string =>
  typeof value === "string" || typeof value === "number"
    ? String(value).trim()
    : "";

/** Turn API tip payloads into a string React can render.
 *  Tips may be a string, `{headline, subtitle}` / `{heading, detail}`, or a list of those. */
export const formatDietTips = (raw: unknown): string => {
  if (raw == null) return "";
  if (Array.isArray(raw)) {
    return raw.map(formatDietTips).filter(Boolean).join("\n");
  }
  if (typeof raw === "string" || typeof raw === "number") return text(raw);
  if (typeof raw === "object") {
    const tip = raw as Record<string, unknown>;
    const heading = text(tip.heading ?? tip.headline);
    const detail = text(tip.detail ?? tip.subtitle);
    const line = [heading, detail].filter(Boolean).join(": ");
    if (line) return line;
    if (tip.tips != null && tip.tips !== raw) return formatDietTips(tip.tips);
  }
  return "";
};
